const mixins = {
    namespaced: true,
    state: {
        yesNo: {
            show: false,
            title: null,
            text: null,
            onYes: undefined,
            onNo: undefined,
        }
    },
    mutations: {
        yesNoShow: (state) => {
            state.yesNo.show = true;
        },
        yesNoHide: (state) => {
            state.yesNo.show = false;
        },
        yesNoText: (state, value) => {
            state.yesNo.text = value;
        },
        yesNoTitle: (state, value) => {
            state.yesNo.title = value;
        },
        yesNoOnYes: (state, next) => {
            state.yesNo.onYes = next;
        },
        yesNoOnNo: (state, next) => {
            state.yesNo.onNo = next;
        },
        yesNoClearEvents: (state) => {
            state.yesNo.onYes = undefined;
            state.yesNo.onNo  = undefined;
        }
    },
    getters: {
        yesNoStatus: (state) => {
            return state.yesNo.show;
        },
        yesNoProps: (state) => {
            return {
                text: state.yesNo.text,
                title: state.yesNo.title,
            };
        },
    },
    actions: {
        yesNoOnYes: (context) => {
            if(context.state.yesNo.onYes !== undefined){
                context.state.yesNo.onYes();
            }
            context.commit('yesNoHide');
            context.commit("yesNoClearEvents");
        },
        yesNoOnNo: (context) => {
            if(context.state.yesNo.onNo !== undefined){
                context.state.yesNo.onNo();
            }
            context.commit('yesNoHide');
            context.commit("yesNoClearEvents");
        },
    },
}

export default mixins;


// WEBPACK FOOTER //
// ./resources/js/store/modules/mixins.js